"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _tab["default"];
  }
});
Object.defineProperty(exports, "TabsHeader", {
  enumerable: true,
  get: function get() {
    return _tabsHeader["default"];
  }
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tab = _interopRequireDefault(require("./tab"));

var _tabsHeader = _interopRequireDefault(require("./tabs-header"));

var Tabs = function Tabs(_ref) {
  var activeTab = _ref.activeTab,
      tabHeadings = _ref.tabHeadings,
      _ref$iconHeadings = _ref.iconHeadings,
      iconHeadings = _ref$iconHeadings === void 0 ? [] : _ref$iconHeadings,
      onTabHeadingClick = _ref.onTabHeadingClick,
      className = _ref.className,
      children = _ref.children,
      numberOfTabs = _ref.numberOfTabs;
  var allIndex = Math.min(numberOfTabs - 1, children.length);
  var headings = (0, _toConsumableArray2["default"])(tabHeadings).splice(0, numberOfTabs - 1).concat('All');
  var selectedTab = Math.min(allIndex, activeTab);
  return _react["default"].createElement("div", {
    className: className
  }, _react["default"].createElement(_tabsHeader["default"], {
    headings: headings,
    icons: iconHeadings,
    selectedTab: selectedTab,
    onTabHeadingClick: onTabHeadingClick
  }), selectedTab === allIndex ? _react["default"].createElement(_tab["default"], {
    isActive: true,
    role: "tabpanel",
    id: "tabpanel".concat(allIndex)
  }, children) : children.splice(0, numberOfTabs).map(function (tab, i) {
    return _react["default"].createElement(_tab["default"], {
      key: "tab".concat(i),
      isActive: selectedTab === i,
      "aria-hidden": selectedTab !== i,
      role: "tabpanel",
      id: "tabpanel".concat(i)
    }, tab);
  }));
};

Tabs.propTypes = {
  activeTab: _propTypes["default"].number,
  tabHeadings: _propTypes["default"].arrayOf(_propTypes["default"].string),
  iconHeadings: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onTabHeadingClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  numberOfTabs: _propTypes["default"].number
};
Tabs.defaultProps = {
  activeTab: 0,
  numberOfTabs: 3
};
var _default = Tabs;
exports["default"] = _default;